import PropTypes from "prop-types";
import IconInstagram from "solar/icons/IconInstagram";
import Button from "solar/components/Button";
import styles from "components/giveaways/SocialButton.module.scss";

export default function SocialButton({ text, url }) {
  return (
    <div className={styles.component}>
      <a href={url} target="_blank" alt={text} rel="noopener noreferrer">
        <Button className={styles.button} icon={<IconInstagram />}>
          {text}
        </Button>
      </a>
    </div>
  );
}

SocialButton.propTypes = {
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};
